import React from 'react'

import profileBg from '../../assets/images/profile-bg.jpg'

/**
 * ProfileBG Component
 *
 * A React component that displays a background image for the profile section.
 *
 * @module profile/ProfileBG
 * @description A React component that displays a background image for the profile section.
 * @example
 * return (
 *   <ProfileBG />
 * )
 *
 * @returns {React.Element} The rendered component with a background image.
 */
export const ProfileBG = () => {
  return (
    <div className="trtui-position-relative trtui-mx-n4 trtui-mt-n4">
      <div className="trtui-profile-wid-bg trtui-profile-setting-img">
        <img src={profileBg} className="trtui-profile-wid-img" alt="profile cover" />
      </div>
    </div>
  )
}
